export enum LDFlags {
  accountNumberBackup = 'account-number-backup',
  showLocalizeWidget = 'ff-show-localize-widget',
  useNysegIraFlow = 'ff-ny-force-show-ira-proof-doc-screen',
  lmiProofDocsState = 'cs-lmi-proof-docs-state',
  lmiSelfAttestationState = 'cs-lmi-self-attestation-state',
  placeCreditCardHold = 'cs-place-card-hold',
  showSpanishLanguage = 'ff-should-set-spanish-language',
  showMicroLearningScreens = 'ff-should-show-micro-learning',
  showFallbackButton = 'ff-show-fallback-button',
  billImageUpload = 'ff-bill-upload-backup',
  showSmsOptInCheckbox = 'ff-show-sms-opt-in',
  showDualBillExplainer = 'ff-show-dual-explainer-screen',
  enableUtilityBillExtraction = 'ff-enable-utility-bill-extraction',
  enableLmiDocumentValidation = 'ff-enable-lmi-document-validation',
  showUtiltityAccountNumberScreen = 'ff-show-account-no-fallback-screen',
  shouldResyncUtilityCredential = 'should-resync-utility-credential',
  allowUserToSkipLmiProof = 'ff_allow_skip_lmi_proof',
  allowPaymentSkipIfUcbAvailable = 'ff-allow-payment-skip-if-ucb-available',
  showLmiNoticeInLegalPage = 'ff-show-lmi-notice-in-legal-page',
  useTwilioVerifyInInputPage = 'ff-use-twilio-verify-in-input-page',
  fetchUtilityEnrollmentOptions = 'ff-utility-enrolment-options',
  showLmiSelfAttestationPostPayment = 'ff-lmi-self-attestation-post-payment',
  shouldBlockSignups = 'ff-block-signups',
  showPersonalizedContractPreview = 'cs-enable-personalized-contracts',
  showRewardsGuidelines = 'ff-show-rewards-guidelines',
  shouldUseNYLmiNewFlow = 'ff-ny-lmi-zone-new-flow',
  shouldUseVALmiFlow = 'ff-va-lmi-new-flow',
  fetchUtilityLmiProofDocOptions = 'ff-utility-lmi-proof-doc-options',
  ffUtilityLmiProofDocsLabelOptions = 'ff-utility-lmi-proof-docs-label-options',
  showOnlySolarLandscapeContracts = 'ff-show-only-solar-landscape-contracts',
  // This flag is used to determine if the user should be
  // allowed to update their language preference in the database
  ffAllowLanguageUpdateApi = 'ff-allow-language-update-api',
  ffUseGeoCoderForMd = 'ff-use-geocoder-logic-for-md',
  ffUseZeroBounceEmailVerification = 'ff-use-zerobounce-email-verification',
  enableAttestationFields = 'ff-enable-extra-fields-for-attestation',
  enableLmiOptionsRadioButtons = 'ff-enable-lmi-option-radio-buttons',
  /**
   * This flag is contains the list of promo codes
   * that are blacklisted for affiliate file drop
   */
  epBlacklistedAffiliatePromoCodes = 'ep-blacklisted-affiliate-promo-codes',
  enableFallbackOnNoServiceAddress = 'ff-fallback-on-no-service-address',
  ffSkipPaymentScreen = 'ff-skip-payment-screen-for-testing',
  ffDefaultSignupProjectId = 'ff-default-signup-project-id',
  ffProofDocTypeRequirePdf = 'ff-proof-doc-type-require-pdf',
  enableManualProofCapture = 'enable-manual-capture-of-proofs',
  ffEnableNJAffirmativeConsent = 'ff-enable-nj-affirmative-consent',
  enableUnitilMA = 'ff-enable-unitil-ma',
  ffEnableContractForm = 'ff-enable-contract-form',
  ffShowBillingPreferenceForMn = 'ff-show-billing-preference-for-mn',
  /**
   * This flag is used to determine if the Name Key for EDI
   * field should be shown in the utility account number screen.
   * It is for unitil ma only.
   */
  ffShowNameKeyForEdi = 'ff-show-name-key-for-edi',
  ffTempPowersetterVALmiChange = 'ff-temp-powersetter-va-lmi-change',
  ffEnableSignnowForIL = 'use-sign-now',
  useNonAcbFlow = 'cs-acb-retirement',
  maintenanceModeEnabled = 'ff-maintenance-mode',
}
